import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, ButtonMode, ButtonSize, Modal } from 'edenred-ui';

import ModalPanel from '@epi-components/Modal/ModalPanel';
import { IBenefitInformationalModalType } from '@epi-models/containers/ManageBenefitGroups';

export const BenefitInformationalModal = ({
  showInformationModal,
  closeModal
}: IBenefitInformationalModalType) => {
  const { t } = useTranslation();

  if (!showInformationModal) {
    return null;
  }

  return (
    <Modal
      open={showInformationModal}
      onClose={closeModal}
      modalBodySx={{
        padding: '0',
        left: '35%',
        'text-align': 'left',
        width: '935px'
      }}
    >
      <ModalPanel
        hideCloseIcon
        onClose={closeModal}
        title={t('components.manage_benefit_lunch.modal.title')}
        primaryActionButton={
          <Button
            id="dialog-close-without-saving"
            onClick={closeModal}
            mode={ButtonMode.Primary}
            size={ButtonSize.Medium}
            minWidth={120}
          >
            {t('components.manage_benefit_lunch.modal.submit')}
          </Button>
        }
      >
        <Box
          height={112}
          display="flex"
          paddingLeft={1}
          sx={{
            whiteSpace: 'pre-line'
          }}
        >
          {t('components.manage_benefit_lunch.modal.body')}
        </Box>
      </ModalPanel>
    </Modal>
  );
};
